import * as React from "react";
import { WizardCruisePWAProps } from "./typings";
import { inject, observer } from "mobx-react";
import { WizardCruisePWAView } from "./WizardCruisePWAView";
import { WizardCruisePWA3PPView } from "./WizardCruisePWA3PPView";

@inject("wizardState")
@observer
export class WizardCruisePWA extends React.Component<WizardCruisePWAProps> {
  constructor(props: WizardCruisePWAProps) {
    super(props);

    const cruiseWizardState = this.props.wizardState.cruiseWizardState;
    cruiseWizardState.overrideConfig(() => {
      cruiseWizardState.config.elementId = this.props.flexComponent.id;
      cruiseWizardState.config.heading.fixedTitle = this.props.flexComponent.model.fixedLobTitle;
      cruiseWizardState.config.heading.lobSubtitleBreakPoint =
        this.props.flexComponent.model.lobSubtitleBreakPoint || cruiseWizardState.config.heading.lobSubtitleBreakPoint;
      cruiseWizardState.config.heading.hideLobTitle = this.props.flexComponent.model.hideLobTitle;
    });
    cruiseWizardState.updateDateFromConfig();
  }

  public render() {
    if (this.props.wizardState.cruiseWizardState.config.displayWizard3pp) {
      return <WizardCruisePWA3PPView {...this.props} />;
    }

    return <WizardCruisePWAView {...this.props} />;
  }
}

export default WizardCruisePWA;
